import type { DirectiveBinding } from 'vue/types/options';
import type { VNode } from 'vue';
import type { ClickOutsideEntry } from './types/entry.type';

function onMousedown(event) {
  for (const { el, binding, vnode } of entries) {
    mousedownHandler(el, binding, vnode, event);
  }
}

function mousedownHandler(el, binding, _vnode, event) {
  if (!(el == event.target || el.contains(event.target)) && typeof binding.value === 'function') {
    binding.value(event);
  }
}

let entries: ClickOutsideEntry[] = [];

const gaClickOutside = {
  name: 'ga-click-outside',
  bind: (el: Element, binding: DirectiveBinding, vnode: VNode) => {
    if (typeof binding.value !== 'function') {
      console.error(
        'v-ga-click-outside: provided expression',
        binding.expression,
        'is not a function.'
      );
      return;
    }
    if (entries.length === 0) {
      document.body.addEventListener('mousedown', onMousedown);
    }
    entries.push({
      el,
      binding,
      vnode,
    });
  },
  unbind: (el: Element) => {
    entries = entries.filter(element => element.el !== el);
    if (entries.length === 0) {
      document.body.removeEventListener('mousedown', onMousedown);
    }
  },
};

export default gaClickOutside;
